import React from "react";
import '../../Styles/Layout/InputArea.css'
import { useAuth } from "../../contexts/AuthContext";
import { useWindow } from "../../contexts/WindowContext";
import { AuthBox } from "./AuthBox";
import { ConvexMessage } from '../../types/message';
import { useChatContext } from "../../contexts/AppDataContext";
import { MessageSecure01Icon } from "hugeicons-react";

interface Props {
  InputArea: React.ReactNode;
  filteredMessages: ConvexMessage[];
  isSubmitting: boolean;
  ScrollToBottomButton: () => React.ReactNode;
  /** Off where the input slot already prompts sign-in (shared chats). */
  showAuthBox?: boolean;
}

export const InputContainer: React.FC<Props> = ({
  InputArea,
  filteredMessages,
  isSubmitting,
  ScrollToBottomButton,
  showAuthBox = true
}) => {
  const auth = useAuth();
  const { windowWidth } = useWindow();
  const {
    isLoadingMessages ,
    currentChatId,
    isIncognito
  } = useChatContext();

  return (
    <div className={`input-container ${auth.isAuthenticated ? '' : 'guest'}`}>
      {showAuthBox && <AuthBox />}
      {ScrollToBottomButton()}
      {((filteredMessages && filteredMessages.length > 0) || windowWidth <= 600 || isSubmitting || isLoadingMessages || (currentChatId && (auth.isLoading || auth.isDataLoading))) ? (
        <>
          {isIncognito && filteredMessages.length > 0 && (
            <div className="incognito-disclaimer">
              <MessageSecure01Icon size={14} color="var(--text-secondary)" />
              <span>Private Chat</span>
            </div>
          )}
          {InputArea}
        </>
      ) : null}
      {!auth.isAuthenticated && !auth.isLoading && filteredMessages.length === 0 && windowWidth > 600 && (
        <div className={`auth-disclaimer ${filteredMessages && filteredMessages.length > 0 ? 'has-messages' : ''}`}>
          <p>
            By sending a message, you agree to our{' '}
            <span className="link-wrapper">
              <a
                href="https://cognora.ca/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms
              </a>
            </span>{' '}
            and{' '}
            <span className="link-wrapper">
              <a
                href="https://cognora.ca/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </span>
            .
          </p>
        </div>
      )}
    </div>
  );
};